import { render, staticRenderFns } from "./Cardcover.vue?vue&type=template&id=1a0a52b0&scoped=true&"
import script from "./Cardcover.vue?vue&type=script&lang=js&"
export * from "./Cardcover.vue?vue&type=script&lang=js&"
import style0 from "./Cardcover.vue?vue&type=style&index=0&id=1a0a52b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0a52b0",
  null
  
)

export default component.exports